import axios from 'axios';
import { setSession } from './authUtils';

const api = axios.create({
    baseURL: 'https://wacrol035api.azurewebsites.net/api',
    //baseURL: 'http://localhost:8080/api',
});

api.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        const originalRequest = error.config;
        let guid = localStorage.getItem('crolGUID');
        delete api.defaults.headers.common['Authorization'];

        if (guid && error.response && error.response.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true;
            return axios.post('https://wacrol035api.azurewebsites.net/api/auth', { GUID: guid }).then((res) => {
                if (res.status === 200) {
                    setSession(res.data.token, '');
                    originalRequest.headers.Authorization = `Bearer ${res.data.token}`;
                    return axios(originalRequest);
                }
            });
        }

        // Si el error es 500, devolvemos un objeto con el mensaje y el status
        if (error.response && error.response.status === 500) {
            return Promise.reject({
                status: 500,
                message:
                    error.response.data && error.response.data.mensaje
                        ? error.response.data.mensaje
                        : 'Internal Server Error',
            });
        }

        return Promise.reject(error);
    }
);

export default api;
